import React, { CSSProperties } from 'react'
import styles from './index.module.less'
import EchoRadioGroup from '@/components/EchoRadioGroup'
import useLocale from '@/utils/useLocale'
import { DatePicker, Space, Message } from '@arco-design/web-react'
import dayjs from 'dayjs'

interface Props {
  dateRange: string
  setDateRange: React.Dispatch<React.SetStateAction<string>>
  style?: CSSProperties
  showDateRange?: boolean
  startTime?: string
  endTime?: string
  setCustomDateRange?: (obj: Record<string, any>) => void
  has180?: boolean
}

function DateSelect({
  showDateRange,
  dateRange,
  setDateRange,
  style = {},
  startTime,
  endTime,
  setCustomDateRange,
  has180,
  ...rest
}: Props) {
  const t = useLocale()
  const otherData = has180 ? [{ id: '180', title: t['influencer.detail.range.180days'] }] : []
  const data = [
    { id: '7', title: t['influencer.detail.range.7days'] },
    { id: '15', title: t['influencer.detail.range.15days'] },
    { id: '30', title: t['influencer.detail.range.30days'] },
    { id: '90', title: t['influencer.detail.range.90days'] },
    ...otherData
  ]
  return (
    <div className={styles.container} style={style}>
      <Space>
        <EchoRadioGroup
          data={data}
          value={dateRange}
          setValue={(val) => {
            setDateRange(val)
            setCustomDateRange?.({
              startTime: '',
              endTime: ''
            })
          }}
        />
        {showDateRange && (
          <div>
            <DatePicker.RangePicker
              allowClear={false}
              mode="date"
              className={styles.datePicker}
              triggerProps={{
                // popupVisible: true,
                className: styles.datePickerPopup
              }}
              // shortcuts={[
              //   {
              //     text: t['product.filter.yesterday'],
              //     value: () => [dayjs(), dayjs().subtract(1, 'days')]
              //   },
              //   {
              //     text: t['product.filter.last_week'],
              //     value: () => [dayjs(), dayjs().subtract(7, 'days')]
              //   },
              //   {
              //     text: t['product.filter.last_month'],
              //     value: () => [dayjs(), dayjs().subtract(30, 'days')]
              //   }
              // ]}
              disabledDate={(current) => current.isAfter(dayjs())}
              defaultPickerValue={[dayjs().month(dayjs().month() - 1), dayjs()]}
              value={startTime && endTime ? [dayjs.unix(Number(startTime)), dayjs.unix(Number(endTime))] : undefined}
              onChange={(_, date) => {
                if (date) {
                  const start = date?.[0].unix()
                  const end = date?.[1].unix()
                  const startDate = dayjs.unix(start)
                  const endDate = dayjs.unix(end)
                  const diffInDays = endDate.diff(startDate, 'day')

                  if (diffInDays > 1000) {
                    Message.warning(t['date1000_tips'])
                  } else {
                    setDateRange('')
                    setCustomDateRange?.({
                      startTime: String(start),
                      endTime: String(end)
                    })
                  }
                }
              }}
            />
          </div>
        )}
      </Space>
    </div>
  )
}

export default DateSelect
